<template>
  <right-menu-item
    v-if="show"
    @click.prevent="clickAdd"
    :class="{ 'muted': bookmarkList.length === 0 }"
    :text="bookmarkList.length === 1 ? $t('Star item') : $t('Star items')"
    :loading="loading"
    icon="star"
  />
  <right-menu-item
    v-if="show && bookmarkedList.length"
    @click.prevent="clickRemove"
    :class="{ 'muted': bookmarkedList.length === 0 }"
    :text="bookmarkedList.length === 1 ? $t('Unstar item') : $t('Unstar items')"
    :loading="loading"
    icon="star"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import useBcBookmarkStore from '@/frontapp/store/bcBookmark'
import addBookmark from '../../mixins/actions/AddBookmark'
import removeBookmark from '../../mixins/actions/RemoveBookmark'
import { trackEvent } from '../../gtm'

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    show () {
      if (this.bcSelectedStore.selectableMap.size === 0 && this.bcSelectedStore.listSelected.length === 0) {
        return false
      }
      
      return this.bcSelectedStore.selectableMap.size > 0 || this.bcSelectedStore.listSelected.length > 0
    },
    bookmarkedList () {
      return this.bcSelectedStore.listSelected.filter(e => e.hidden === null && this.bcBookmarkStore.isBookmarked(e))
    },
    bookmarkList () {
      return this.bcSelectedStore.listSelected.filter(e => e.hidden === null && !this.bcBookmarkStore.isBookmarked(e))
    },
    ...mapStores(useBcSelectedStore, useBcFolderStore, useBcBookmarkStore),
  },
  methods: {
    async clickAdd() {
      this.loading = true
      const documents = this.bookmarkList
        .filter(e => e.type === 'document')

      const folders = this.bookmarkList
        .filter(e => e.type === 'folder')

      if (documents.length === 0 && folders.length === 0) {
        return
      }

      await addBookmark(documents, folders)
      this.bcSelectedStore.resetSelected()
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'addBookmark')
    },
    async clickRemove() {
      this.loading = true
      const documents = this.bookmarkedList
        .filter(e => e.type === 'document')

      const folders = this.bookmarkedList
        .filter(e => e.type === 'folder')

      if (documents.length === 0 && folders.length === 0) {
        return
      }

      await removeBookmark(documents, folders)
      this.bcSelectedStore.resetSelected()
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'removeBookmark')
    },
  },
}
</script>

<style lang="scss" scoped></style>
